import { useEffect, useState } from 'react';
import { applySeason, resolveSeason, type Season } from '../lib/seasons';

function readSeason(): Season {
  return resolveSeason(new Date(), window.location.search);
}

/** Current month theme. Rechecks once a minute so a kiosk flips at midnight. */
export function useSeason(): Season {
  const [season, setSeason] = useState<Season>(readSeason);

  useEffect(() => {
    const tick = () => {
      const next = readSeason();
      setSeason((prev) => (prev.id === next.id ? prev : next));
    };
    tick();
    const id = window.setInterval(tick, 60_000);
    document.addEventListener('visibilitychange', tick);
    window.addEventListener('popstate', tick);
    return () => {
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', tick);
      window.removeEventListener('popstate', tick);
    };
  }, []);

  useEffect(() => {
    applySeason(document.documentElement, season);
  }, [season]);

  return season;
}
